import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 17c0-6.075-4.925-11-11-11S6 10.925 6 17c0 5.49 4.023 10.041 9.281 10.866V20.18h-2.793V17h2.793v-2.423c0-2.757 1.643-4.28 4.155-4.28 1.204 0 2.462.215 2.462.215v2.707h-1.387c-1.366 0-1.792.848-1.792 1.718V17h3.05l-.487 3.18h-2.563v7.686C23.977 27.041 28 22.49 28 17Z",
  fill: "#1877F2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m21.282 20.18.487-3.18h-3.05v-2.063c0-.87.426-1.718 1.792-1.718h1.387v-2.707s-1.259-.215-2.462-.215c-2.513 0-4.155 1.523-4.155 4.28V17h-2.793v3.18h2.793v7.686a11.078 11.078 0 0 0 3.437 0V20.18h2.564Z",
  fill: "#fff"
})));

export { SvgSmFacebook as default };
